import { CoreAPI, createCommonLocationMethods } from '@hero/sdk-core';

export function createLocationAPI(coreAPI: CoreAPI) {
  return {
    // Common location methods (available across all SDKs)
    ...createCommonLocationMethods(coreAPI),
  };
}
